import { LoaderFunctionArgs } from 'react-router-dom'

export const lazyLoader =
  <T extends () => any>(importer: T) =>
  async ({ request, params }: LoaderFunctionArgs) => {
    const { loader } = await importer()
    return loader ? loader({ request, params }) : null
  }
